import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
// import CountUp from "react-countup";
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Breadcrumbs from "../common/breadcrumbs";
import Aos from "aos";
// import { Link } from "react-router-dom";
// import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { TbCalendarDollar } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";

const How = () => {
    //   const testimonials = [
    //     {
    //       id: 1,
    //       name: "Rabien Ustoc",
    //       image: "/assets/img/profiles/avatar-02.jpg",
    //       rating: 5.0,
    //       review:
    //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     },
    //     {
    //       id: 2,
    //       name: "Valerie L. Ellis",
    //       image: "/assets/img/profiles/avatar-03.jpg",
    //       rating: 5.0,
    //       review:
    //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     },
    //     {
    //       id: 3,
    //       name: "Laverne Marier",
    //       image: "/assets/img/profiles/avatar-04.jpg",
    //       rating: 5.0,
    //       review:
    //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     },
    //     {
    //       id: 4,
    //       name: "Sydney Salmons",
    //       image: "/assets/img/profiles/avatar-06.jpg",
    //       rating: 5.0,
    //       review:
    //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     },
    //     {
    //       id: 5,
    //       name: "Lucas Moquin",
    //       image: "/assets/img/profiles/avatar-07.jpg",
    //       rating: 5.0,
    //       review:
    //         "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    //     },
    //     // Add more testimonials as needed
    //   ];

    //   const settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 2,
    //     slidesToScroll: 1,
    //   };

    useEffect(() => {
        Aos.init({ duration: 1200, once: true });
    }, []);
    return (
        <>

            <section className="section services py-2" >

                <div className="container">
                    {/* Heading title*/}
                    <div className="section-heading" data-aos="fade-down">
                        <h2>How It Works</h2>
                        {/* <p>
                            Lorem Ipsum has been the industry standard dummy text ever since
                            the 1500s,
                        </p> */}
                    </div>
                    {/* /Heading title */}
                    <div className="services-work">
                        <div className="row">
                            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                                <div className="services-group   p-0">
                                    <div className="services-icon border-primary">
                                        <ImageWithBasePath
                                            className="icon-img bg-primary"
                                            src="assets/img/icons/services-icon-03.svg"
                                            // src="assets/img/icons/services-icon-01.svg"
                                            alt="Choose Locations"
                                        />
                                    </div>
                                    <div className="services-content">
                                        <h3 className="">1. Choose Your Car</h3>
                                        <p>   Browse our fleet and select the perfect ride for your needs.  </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                                <div className="services-group   p-0">
                                    <div className="services-icon border-primary">
                                        <ImageWithBasePath
                                            className="icon-img bg-primary"
                                            src="assets/img/icons/services-icon-02.svg"
                                            alt="Choose Locations"
                                        />
                                    </div>
                                    <div className="services-content">
                                        <h3>2. Book Exclusively</h3>
                                        <p>   Reserve your car for your chosen term. No sharing—it&#39;s all yours until drop-off.  </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                                <div className="services-group   p-0">
                                    <div className="services-icon border-primary">

                                        <TbCalendarDollar 

                                         className="icon-img bg-primary"
                                         style={{
                                            width: 70,
                                            height: 70,
                                            color: "#fff"
                                        }} />

                                        {/* <ImageWithBasePath
                                            className="icon-img bg-primary"
                                            src="assets/img/icons/services-icon-03.svg"
                                            alt="Choose Locations"
                                        /> */}
                                    </div>
                                    <div className="services-content">
                                        <h3>3. Pay Daily</h3>
                                        <p>    Enjoy the convenience of daily payments while enjoying the benefits of a long-term rental.   </p>
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                                <div className="services-group  p-0">
                                    <div className="services-icon border-primary">
                                        <ImageWithBasePath
                                            className="icon-img bg-primary"
                                            src="assets/img/icons/services-icon-03.svg"
                                            alt="Choose Locations"
                                        />
                                    </div>
                                    <div className="services-content">
                                        <h3>4. Drive Away</h3>
                                        <p> With insurance, maintenance, and unlimited mileage included, you’re set for the road ahead. </p>
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
                                <div className="services-group p-0">
                                    <div className="services-icon border-primary">
                                         <BiSupport  className="icon-img bg-primary"
                                         style={{
                                            width: 58,
                                            height: 58,
                                            color: "#fff"
                                        }} />
                                    </div>
                                    <div className="services-content">
                                        <h3>5. Support When You Need It</h3>
                                        <p> Got a question? Our friendly team is available via text 24/7 and by phone for 12 hours a day.    </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {/* /About */}


        </>
    );
};

export default How;
